/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import { datadogRum } from "@datadog/browser-rum"

const isClient = typeof window !== "undefined"
const isProductionBuild = process.env.NODE_ENV === "production"

// Determine environment based on hostname
const getEnvironment = () => {
  if (!isClient) return "server"
  const hostname = window.location.hostname
  if (hostname === "www.hult.edu" || hostname === "hult.edu") {
    return "production"
  }
  if (hostname === "staging.hult.edu") {
    return "staging"
  }
  if (hostname === "qa.hult.edu") {
    return "development"
  }
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "local"
  }
  return "unknown"
}

let initialized = false

/**
 * Called when the Gatsby browser runtime first starts.
 * Initialize Datadog RUM here to track all page views and user interactions.
 */
export const onClientEntry = () => {
  if (!isClient || initialized) return

  // Only initialize in production builds
  if (!isProductionBuild) {
    return
  }

  const env = getEnvironment()

  datadogRum.init({
    applicationId: "501668be-dc34-4c01-9576-8cd15797b485",
    clientToken: "pubf8da8086075b0e84f55a866dabd1efab",
    site: "datadoghq.com",
    service: "hult-gatsby",
    env,
    // Reduced from 100% to 5% to control RUM session volume (Apr 2026).
    // At 100%, this site alone generated ~225K sessions/month,
    // pushing total RUM costs well above the ~$1000/year target.
    sessionSampleRate: 5,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackBfcacheViews: true,
    defaultPrivacyLevel: "mask-user-input",
  })

  initialized = true
}
